import { render } from "./FeedEditComment.vue?vue&type=template&id=1798a281&ts=true"
import script from "./FeedEditComment.vue?vue&type=script&lang=ts"
export * from "./FeedEditComment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__